module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-angry-fill-76c20cf1.svg";